import React from 'react';
import Slider from 'react-slick';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import { VideoPlayer } from 'components/MediaPlayer/VideoPlayer';

import { classNames, isEmpty, isString } from 'util/utils';

import { FILE_URLS, getMediaUrl, LAB_LINKS, MEDIA_TYPES } from 'constants/Common';

import Embed from './Embed';
import Image from './Image';
import MagnifierImage from './MagnifierImage';
import NotAvailable from './NotAvailable';
import signalSvg from './traffic-signal.svg';

import camSvg from 'assets/svg/camera.svg';
import certSvg from 'assets/svg/certi.svg';
import videoSvg from 'assets/svg/video.svg';

function DiamondDetailLeft(props) {
  const { data, activeTab, flags, currentSubTab, ..._props } = props;

  const [imgSlider, setImgSlider] = React.useState();
  const [haSlider, setHaSlider] = React.useState();
  const [imgNav, setMainNav] = React.useState();
  const [haNav, setHaNav] = React.useState();

  const propsRef = React.useRef(props);

  const toggle = React.useMemo(() => {
    const { activeTabChange } = propsRef.current;
    return (tab) => () => activeTabChange(tab);
  }, []);

  const showMp4Video = React.useMemo(() => {
    return true;
  }, [data?.isTradingStone, data?.locNm]);

  React.useEffect(() => {
    propsRef.current = props;
  }, [props]);

  React.useEffect(() => {
    const { activeTabChange } = propsRef.current;
    activeTabChange(showMp4Video ? 'tab-mp4' : 'tab-main');
  }, [showMp4Video]);

  if (isEmpty(data)) return null;

  return (
    <>
      <Nav tabs className="customerMaintab diamondDetailTopTab">
        <NavItem>
          <NavLink className={classNames([activeTab === 'tab-main' && 'active'])} onClick={toggle('tab-main')}>
            Image
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink className={classNames([activeTab === 'tab-video' && 'active'])} onClick={toggle('tab-video')}>
            Video
          </NavLink>
        </NavItem>
        {showMp4Video && (
          <NavItem>
            <NavLink className={classNames([activeTab === 'tab-mp4' && 'active'])} onClick={toggle('tab-mp4')}>
              MP4
            </NavLink>
          </NavItem>
        )}
        <NavItem>
          <NavLink className={classNames([activeTab === 'tab-hna' && 'active'])} onClick={toggle('tab-hna')}>
            H&A
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink className={classNames([activeTab === 'tab-cert' && 'active'])} onClick={toggle('tab-cert')}>
            Certificate
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} {..._props}>
        <TabPane tabId={'tab-main'} activeTab={activeTab}>
          <Slider asNavFor={imgNav} ref={setImgSlider} arrows={false}>
            <div className="diamondDetailImageBox">
              <MagnifierImage image={FILE_URLS.img.replace('***', data.mfgStnId)}>
                <NotAvailable type="Image" imgSrc={camSvg} style={{ height: '450px' }} />
              </MagnifierImage>
            </div>
            <div className="diamondDetailImageBox">
              <MagnifierImage image={FILE_URLS.lightBlack.replace('***', data.mfgStnId)}>
                <NotAvailable type="Image" imgSrc={camSvg} style={{ height: '450px' }} />
              </MagnifierImage>
            </div>
          </Slider>
          <Slider
            ref={setMainNav}
            asNavFor={imgSlider}
            className="smallSliderBlock smallSliderBlockimage"
            beforeChange={currentSubTab}
            slidesToShow={2}
            swipeToSlide
            focusOnSelect
          >
            <div className="smallSliderImage">
              <Image src={FILE_URLS.img.replace('***', data.mfgStnId)}>
                <img src={signalSvg} alt="Resource not found" />
              </Image>
            </div>
            <div className="smallSliderImage">
              <Image src={FILE_URLS.lightBlack.replace('***', data.mfgStnId)}>
                <img src={signalSvg} alt="Resource not found" />
              </Image>
            </div>
          </Slider>
        </TabPane>
        <TabPane tabId={'tab-video'} activeTab={activeTab}>
          {activeTab === 'tab-video' && (
            <div className="diamondDetailImageBox htmlViewImage">
              {flags?.videoFile ? (
                <Embed src={FILE_URLS.videoFile.split('***').join(data.mfgStnId)}>
                  <NotAvailable type="Video" imgSrc={videoSvg} style={{ height: '450px' }} />
                </Embed>
              ) : (
                <NotAvailable type="Video" imgSrc={videoSvg} style={{ height: '450px' }} />
              )}
            </div>
          )}
        </TabPane>
        {showMp4Video && (
          <TabPane tabId={'tab-mp4'} activeTab={activeTab}>
            <Slider infinite={false} arrows={false}>
              <div className="diamondDetailImageBox">
                {flags?.mp4Video ? (
                  <VideoPlayer
                    aspectRatio="6:5"
                    src={getMediaUrl(MEDIA_TYPES.MP4_VIDEO_360, data?.vStnId)}
                    height="100%"
                    width="100%"
                    responsive
                    controls
                    autoplay
                    loop
                  />
                ) : (
                  <NotAvailable type="Video" imgSrc={videoSvg} style={{ height: '450px' }} />
                )}
              </div>
            </Slider>
          </TabPane>
        )}
        <TabPane tabId={'tab-hna'} activeTab={activeTab}>
          <Slider asNavFor={haNav} ref={setHaSlider} arrows={false}>
            <div className="diamondDetailImageBox">
              <MagnifierImage image={FILE_URLS.arrowFile.replace('***', data.mfgStnId)}>
                <NotAvailable type="Image" imgSrc={camSvg} style={{ height: '450px' }} />
              </MagnifierImage>
            </div>
            <div className="diamondDetailImageBox">
              <MagnifierImage image={FILE_URLS.hAFile.replace('***', data.mfgStnId)}>
                <NotAvailable type="Image" imgSrc={camSvg} style={{ height: '450px' }} />
              </MagnifierImage>
            </div>
          </Slider>
          <Slider
            ref={setHaNav}
            asNavFor={haSlider}
            className="smallSliderBlock smallSliderBlockimage"
            beforeChange={currentSubTab}
            slidesToShow={2}
            swipeToSlide
            focusOnSelect
          >
            <div className="smallSliderImage">
              <Image src={FILE_URLS.arrowFile.replace('***', data.mfgStnId)}>
                <img src={signalSvg} alt="Resource not found" />
              </Image>
            </div>
            <div className="smallSliderImage">
              <Image src={FILE_URLS.hAFile.replace('***', data.mfgStnId)}>
                <img src={signalSvg} alt="Resource not found" />
              </Image>
            </div>
          </Slider>
        </TabPane>
        <TabPane tabId={'tab-cert'} activeTab={activeTab}>
          <div className="diamondDetailImageBox">
            {flags?.certFile ? (
              <Embed src={getMediaUrl(MEDIA_TYPES.PDF_LAB_CERT, data?.rptNo)}>
                <NotAvailable type="Image" imgSrc={certSvg} style={{ height: '450px' }} />
              </Embed>
            ) : (
              <NotAvailable type="Certificate" imgSrc={certSvg} style={{ height: '450px' }}>
                {isString(LAB_LINKS[data.lbNm.toUpperCase()]) && (
                  <span>
                    <a
                      href={LAB_LINKS[data.lbNm.toUpperCase()].replace('***', data.rptNo)}
                      style={{ color: 'rgb(0, 140, 186)', fontWeight: 600 }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Click here for certificate
                    </a>
                  </span>
                )}
              </NotAvailable>
            )}
          </div>
        </TabPane>
      </TabContent>
    </>
  );
}

export default DiamondDetailLeft;
